'use strict';

class NavigationExpander {
    constructor() {
        document.querySelector('.nav-tree--level-0').addEventListener('click', (e) => this.expandCollapseMenuItem(e));
    }
    expandCollapseMenuItem(e) {
        var button = e.target;
        while (button != null && !button.matches('button')) {
            button = button.parentElement;
        }
        if (button == null) {
            return;
        }
        e.preventDefault();
        this.toggleButton(button);

        var containerLi = button.parentElement.parentElement;
        var ul = containerLi.querySelector('ul');

        if (!ul || ul.classList.contains('hidden')) { //collapse all
            button.setAttribute('aria-expanded', 'true');
            if (!ul) {
                this.loadNavigationFragment(
                    button.dataset.id,
                    button.dataset.level,
                    (fragment) => {
                        containerLi.insertAdjacentHTML('beforeend', fragment);
                        ul = containerLi.querySelector('ul');
                    });
            } else {
                ul.classList.remove('hidden');
            }

        } else {
            button.setAttribute('aria-expanded', 'false');
            if (ul) {
                ul.classList.add('hidden');
            }
        }
    }

    loadNavigationFragment(id, level, callback) {
        var noCacheHeaders= {
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        };
        fetch(`/navigation/loadnavigationfragment/?id=${id}&level=${level}`,
        {
            headers: noCacheHeaders,
            method: 'GET',
            credentials: 'include'

        }).then(resp => {
            return resp.text();
        }).then(html => {
            callback(html);
        });
    }

    toggleButton(button) {
        if (button.classList.contains('expanded')) {
            button.classList.remove('expanded');
            button.querySelector('span').innerText = "Expandera meny";
            button.querySelector('i').innerText = "add_circle_outline";
        } else {
            button.classList.add('expanded');
            button.querySelector('span').innerText = "Slå ihop meny";
            button.querySelector('i').innerText = "remove_circle_outline";
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new NavigationExpander();
});




// WEBPACK FOOTER //
// ./Components/Navigation/NavigationExpander.js